import * as React from "react";
import AsyncSelect from "react-select/lib/Async";
import { ValueType } from "react-select/lib/types";

import { HorsesEndpoints } from "../../endpoints/HorseEndpoints";
import { SimpleHorse, HorseMaleFemale } from "../../model/Horse";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHorseHead, faPhone, faMapPin, faPlus, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const CREATE_NEW = -1;

export interface Props {
    horseEndpoints: HorsesEndpoints;
    isDisabledLink?: boolean;
    style?: string;
    showGait?: boolean;
    value: SimpleHorse | null;
    include?: "MALE" | "FEMALE" | "BOTH";
    onChange?: (horse: SimpleHorse | null) => void;

    showCreate?: boolean;
    onCreate?: () => void;
}

export default class HorseSelect extends React.Component<Props, {}> {
    private latestHorseList: Array<SimpleHorse> = [];
    private mostRecentRequest: number = 1;

    constructor(props: Props) {
        super(props);
    }

    createOption = () => {
        return {
            label: (
                <button type="button" className="btn btn-primary btn-sm">
                    <FontAwesomeIcon icon={faPlus} /> Create new...
                </button>
            ),
            value: CREATE_NEW
        };
    };

    loadOptions = async (fullTextSearch: string) => {
        const requestNo = ++this.mostRecentRequest;
        const horseList = await this.props.horseEndpoints.getHorseList(15, 0, undefined, { fullTextSearch });

        if (requestNo !== this.mostRecentRequest) {
            // A newer request has been ordered, this one is no longer relevant :(
            return [];
        }

        this.latestHorseList = horseList.results;

        const options = horseList.results
            .filter(
                h =>
                    !h.sex ||
                    this.props.include === "BOTH" ||
                    (this.props.include === "MALE" && h.sex.maleFemale === HorseMaleFemale.MALE) ||
                    (this.props.include === "FEMALE" && h.sex.maleFemale === HorseMaleFemale.FEMALE)
            )
            .map(horse => this.horseToOption(horse));
        if (this.props.showCreate) {
            options.unshift(this.createOption());
        }
        return options;
    };

    render() {
        return (
            <AsyncSelect
                isDisabled={this.props.isDisabledLink}
                loadOptions={this.loadOptions}
                defaultOptions={[this.createOption()]}
                cacheOptions={false}
                isClearable={true}
                className={this.props.style}
                value={this.horseToOption(this.props.value)}
                onChange={(ref: any) => {
                    if (ref && ref.value === CREATE_NEW && this.props.onCreate) {
                        this.props.onCreate();
                    } else if (this.props.onChange) {
                        const horse = ref ? this.latestHorseList.find(c => c.id === ref.value) || null : null;
                        this.props.onChange(horse);
                    }
                }}
            />
        );
    }

    private horseToOption(horse: SimpleHorse | null): ValueType<{ label: React.ReactNode; value: number }> {
        if (!horse) {
            return null;
        }

        const label = (
            <div>
                <FontAwesomeIcon icon={faHorseHead} />
                &nbsp;{`${horse.name}`}
                {this.props.showGait && horse.gait && <span className="ml-2 mr-2">({horse.gait.abbreviation})</span>}
            </div>
        );

        return { label, value: horse.id };
    }
}



// WEBPACK FOOTER //
// ./src/components/common/HorseSelect.tsx